"use client";

import { c as _c } from "react/compiler-runtime";
import { Fab, Menu, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useEvent } from "@/app/(context)/analytics-context";
import MaxWidthWrapper from "@/components/MaxWidthWrapper";
const FabIconModal = t0 => {
  const $ = _c(36);
  const {
    digitalProfile
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== theme.breakpoints) {
    t1 = theme.breakpoints.down("sm");
    $[0] = theme.breakpoints;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMobile = useMediaQuery(t1);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const {
    phoneNumber,
    fccMembership
  } = digitalProfile;
  const t2 = phoneNumber ?? "";
  let phoneWithCountryCode;
  let t3;
  if ($[2] !== t2) {
    const sanitizedPhone = String(t2).replace(/[\s-]/g, "");
    phoneWithCountryCode = sanitizedPhone.startsWith("+91") ? sanitizedPhone : `+91${sanitizedPhone}`;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = /\D/g;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t3 = phoneWithCountryCode.replace(t4, "");
    $[2] = t2;
    $[3] = phoneWithCountryCode;
    $[4] = t3;
  } else {
    phoneWithCountryCode = $[3];
    t3 = $[4];
  }
  const whatsAppNumber = t3;
  Object.keys(fccMembership);
  let handleClick;
  let handleClose;
  let handleDialClick;
  let handleOpenWhatsApp;
  if ($[6] !== phoneWithCountryCode || $[7] !== whatsAppNumber) {
    handleDialClick = () => {
      window.open(`tel:${phoneWithCountryCode}`);
      handleClose();
    };
    handleOpenWhatsApp = () => {
      const url = `https://wa.me/${whatsAppNumber}?text=${encodeURIComponent("Hi, I'd like to discuss some details about your work.")}`;
      window.open(url, "_blank");
      handleClose();
    };
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = event => {
        setAnchorEl(event.currentTarget);
      };
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    handleClick = t4;
    handleClose = () => {
      setAnchorEl(null);
    };
    $[6] = phoneWithCountryCode;
    $[7] = whatsAppNumber;
    $[8] = handleClick;
    $[9] = handleClose;
    $[10] = handleDialClick;
    $[11] = handleOpenWhatsApp;
  } else {
    handleClick = $[8];
    handleClose = $[9];
    handleDialClick = $[10];
    handleOpenWhatsApp = $[11];
  }
  let t4;
  if ($[13] !== handleClick || $[14] !== isMobile) {
    t4 = isMobile && <Fab onClick={handleClick} aria-label="add" sx={{
      position: "fixed",
      right: 16,
      bottom: 40,
      backgroundColor: "#C2C8F5",
      height: "56px",
      width: "56px",
      borderRadius: "16px",
      "&:hover": {
        backgroundColor: "#C2C8F5"
      },
      "&:active": {
        backgroundColor: "#C2C8F5"
      },
      "&:focus": {
        backgroundColor: "#C2C8F5"
      }
    }}><CallOutlinedIcon htmlColor="#004BEE" /></Fab>;
    $[13] = handleClick;
    $[14] = isMobile;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  let t6;
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      vertical: "top",
      horizontal: "center"
    };
    t6 = {
      vertical: "bottom",
      horizontal: "center"
    };
    t7 = {
      transform: "translateY(-10px)"
    };
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      width: 200,
      display: "flex",
      alignItems: "center"
    };
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CallOutlinedIcon sx={{
      marginRight: "12px"
    }} htmlColor="#004BEE" />;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== handleDialClick) {
    t10 = <MenuItem onClick={handleDialClick} sx={t8}>{t9}Call</MenuItem>;
    $[21] = handleDialClick;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      width: 200,
      display: "flex",
      alignItems: "center"
    };
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <WhatsAppIcon sx={{
      marginRight: "12px"
    }} htmlColor="#004BEE" />;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== handleOpenWhatsApp) {
    t13 = <MenuItem onClick={handleOpenWhatsApp} sx={t11}>{t12}WhatsApp</MenuItem>;
    $[25] = handleOpenWhatsApp;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== anchorEl || $[28] !== handleClose || $[29] !== open || $[30] !== t10 || $[31] !== t13) {
    t14 = <Menu anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={t5} transformOrigin={t6} sx={t7}>{t10}{t13}</Menu>;
    $[27] = anchorEl;
    $[28] = handleClose;
    $[29] = open;
    $[30] = t10;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14 || $[34] !== t4) {
    t15 = <MaxWidthWrapper>{t4}{t14}</MaxWidthWrapper>;
    $[33] = t14;
    $[34] = t4;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};
export default FabIconModal;